import { normalizeString } from './normalizeString'

export function normalizedCompare(a: string, b: string) {
  return normalizeString(a) === normalizeString(b)
}
